import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RegisterComponent } from '../register/register.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidatePhoneComponent } from '../validate-phone/validate-phone.component';
import { MainService } from 'src/app/Services/service.service';

@Component({
  selector: 'app-validate-phone-holder',
  templateUrl: './validate-phone-holder.component.html',
  styleUrls: ['./validate-phone-holder.component.scss']
})
export class ValidatePhoneHolderComponent implements OnInit, AfterViewInit {

  public enablePhoneRegConfirm:boolean = false; 

  ngAfterViewInit(): void {

    const userDataObject = JSON.parse(atob(this.route.snapshot.paramMap.get("user_data")));

    if(this.enablePhoneRegConfirm){
    const dialogRef = this.dialog.open(ValidatePhoneComponent, {
      width: "650px",
      disableClose: false,
      data:{
        userData: userDataObject
      }
    })

    dialogRef.afterClosed().subscribe(v=>{
      if(!dialogRef.componentInstance.afterRegClose)
      {
       //   window.history.back();
      }
    })
    }else{
      this.router.navigate(['']);
    }
  }

  constructor(private route: ActivatedRoute,public dialog: MatDialog, public services: MainService,  private router: Router) {

    this.enablePhoneRegConfirm = services.enablePhoneRegConfirm;

   }


  get currentUserId(): number {
    return this._currentUserId;
  }

  set currentUserId(value: number) {
    this._currentUserId = value;
  }

  private _currentUserId: number = 0;
  private _currentUserPhone: string = '';

  get currentUserPhone(): string {
    return this._currentUserPhone;
  }

  set currentUserPhone(value: string) {
    this._currentUserPhone = value;
  }
  
  ngOnInit() {
    // const userDataObject = JSON.parse(atob(this.route.snapshot.paramMap.get("user_data")));

    // if (userDataObject) {
    //   this.currentUserId = parseInt(userDataObject.userId);
    //   this.currentUserPhone = userDataObject.userPhone;
    //  // this.sendPhoneValidationSms(null)
    // }

  }

}
